import { apiEndpoints } from '@/apiEndpoints';
import { VehicleWithChauffeurResponse } from '@/types/benefits/VehicleWithChauffeurResponse';
import { SupportedLocale } from '@/types/supported-locale.type';
import axios from 'axios';

export const createVehicleWithChauffeur = async (data: FormData) =>
  axios.post(apiEndpoints.vehiclesWithChauffeur.base, data);

export const updateVehicleWithChauffeur = async (
  benefitId: string,
  data: FormData,
  language?: SupportedLocale,
) =>
  axios.put(apiEndpoints.vehiclesWithChauffeur.detail(benefitId), data, {
    params: { language },
  });

export const findVehicleWithChauffeur = async (benefitId: string) => {
  const result = await axios.get<VehicleWithChauffeurResponse>(
    apiEndpoints.vehiclesWithChauffeur.detail(benefitId),
  );
  return result.data;
};

export const duplicateVehicleWithChauffeur = async (
  benefitId: string,
  fields: string[],
) => {
  const result = await axios.post(
    apiEndpoints.vehiclesWithChauffeur.duplicate(benefitId),
    { fields },
  );
  return result.data;
};
